export default __webpack_public_path__ + "static/media/3.2ce9c9f5.jpg";